import { render } from "./ProductoInfo.vue?vue&type=template&id=337dde2e"
import script from "./ProductoInfo.vue?vue&type=script&lang=js"
export * from "./ProductoInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__